export enum MediaPlayerState {
  Playing,
  Paused,
  Stopped,
}

export type MediaPlayerCommand = keyof MediaPlayer &
  ("pause" | "resume" | "stop" | "previous" | "next");

export default interface MediaPlayer {
  readonly state: MediaPlayerState;
  can(command: MediaPlayerCommand): boolean;
  pause(): void | Promise<void>;
  resume(): void | Promise<void>;
  stop(): void | Promise<void>;
  previous(): void | Promise<void>;
  next(): void | Promise<void>;
}
